import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-searchy-search',
  templateUrl: './searchy-search.component.html',
  styleUrls: ['./searchy-search.component.css']
})
export class SearchySearchComponent implements OnInit {
 
  public searchText: string;
  public customerData: any;

  constructor() { }

  ngOnInit() {
    this.customerData = [
      { "name": 'passing the delariva', "Age": 'passing', "blog": '/delarivaPassing' },
      { "name": 'passing the full guard', "Age": 'passing', "blog": '/closedGuardPassing' },
      { "name": 'passing the open guard', "Age": 'passing', "blog": '/openGuardPassing' },
      { "name": 'passing the half guard', "Age": 'passing', "blog": '/halfGuardPassing' },

      { "name": 'side control escapes', "Age": 'escaping', "blog": '/sideControlEscaping' },
      { "name": 'knee on belly escapes', "Age": 'escaping', "blog": '/kneeOnBellyEscaping' },
      { "name": 'mount escapes', "Age": 'escaping', "blog": '/mountEscaping' },
      { "name": 'turtle escapes', "Age": 'escaping', "blog": '/turtleEscaping' },
      { "name": 'back escapes', "Age": 'escaping', "blog": '/backEscaping' },
      { "name": 'armbar escapes', "Age": 'escaping', "blog": '/armbarEscaping' },
      { "name": 'triangle escapes', "Age": 'escaping', "blog": '/triangleEscaping' },
      { "name": 'kimura escapes', "Age": 'escaping', "blog": '/kimuraEscaping' },
      { "name": 'north south escapes', "Age": 'escaping', "blog": '/northSouthEscaping' },

      { "name": 'half guard attacks', "Age": 'attacking', "blog": '/halfGuardAttacking' },
      { "name": 'mount attacks', "Age": 'attacking', "blog": '/mountAttacking' },
      { "name": 'delariva attacks', "Age": 'attacking', "blog": '/delarivaAttacking' },
      { "name": 'closed guard attacks', "Age": 'attacking', "blog": '/closedGuardAttacking' },
      { "name": 'back attacks', "Age": 'attacking', "blog": '/backAttacking' },
      { "name": 'armbar attacks', "Age": 'attacking', "blog": '/armbarAttacking' },
      { "name": 'triangle attacks', "Age": 'attacking', "blog": '/triangleAttacking' },
      { "name": 'turtle attacks', "Age": 'attacking', "blog": '/turtleAttacking' },
      { "name": 'kimura attacks', "Age": 'attacking', "blog": '/kimuraAttacking' },
      { "name": 'side control attacks', "Age": 'attacking', "blog": '/sideControlAttacking' },
      { "name": 'knee on belly attacks', "Age": 'attacking', "blog": '/kneeOnBellyAttacking' },
      { "name": 'north south attacks', "Age": 'attacking', "blog": '/northSouthAttacking' },
      { "name": 'open guard attacks', "Age": 'attacking', "blog": '/openGuardAttacking' },
      { "name": '50/50 attacks', "Age": 'attacking', "blog": '/fiftyFiftyAttacking' },];
  }
}


// WEBPACK FOOTER //
// ./src/app/searchy-search/searchy-search.component.ts